<!--
  Preis- und Leistungsverzeichnis (Empfehlung Anwalt, 21.08.2026): Die AGB
  bleiben preisfrei und verweisen hierher. Preise und Leistungen können auf
  dieser Seite für künftige Vertragsschlüsse jederzeit angepasst, ergänzt
  oder eingestellt werden, ohne die AGB zu ändern. Für Bestandsverträge gilt
  die bei Vertragsschluss veröffentlichte Fassung — bei Änderungen deshalb
  immer das Stand-Datum unten aktualisieren.
-->
<div class="rechtstext">
  <h1>Preis- und Leistungsverzeichnis</h1>
  <p class="leise">
    von IT-Service Karsten Fischer (nachfolgend „Anbieter"). Dieses Verzeichnis ergänzt die
    <a href="/agb">Allgemeinen Geschäftsbedingungen</a> und benennt die aktuell angebotenen
    Leistungen und Entgelte.
  </p>

  <h2>1. IT-Dienstleistungen (leistungsbezogene Abrechnung)</h2>
  <p>
    Abgerechnet wird ausschließlich bei tatsächlicher Inanspruchnahme, je Betreuungseinheit von bis
    zu 30 Minuten. Es fallen keine Grundgebühren und keine monatlichen Pauschalen an.
  </p>
  <table>
    <tbody>
      <tr>
        <td>Telefonische Erstberatung und Problemanalyse</td>
        <td>kostenlos</td>
      </tr>
      <tr>
        <td>Remote-Leistungen (Fernwartung, Beratung)</td>
        <td>39,00&nbsp;€ je Betreuungseinheit</td>
      </tr>
      <tr>
        <td>Vor-Ort-Leistungen (im veröffentlichten Servicegebiet)</td>
        <td>49,50&nbsp;€ je Betreuungseinheit</td>
      </tr>
      <tr>
        <td>
          Schritt-für-Schritt-Anleitung (PDF) zu einem Support-Anliegen, auf Wunsch statt einer
          Betreuungseinheit; Bezahlung vorab über PayPal. Wird zum selben Anliegen anschließend
          eine Fernwartung beauftragt, wird der Preis voll angerechnet.
        </td>
        <td>1,99&nbsp;€ je Anleitung</td>
      </tr>
      <tr>
        <td>
          Fernwartung durch den Helpdesk über KF Fernwartung (Windows-PC), Fallpauschale je Anliegen. Wird
          vor Beginn mit der Erlaubnis zur Fernwartung angekündigt, vorab über PayPal bezahlt und nur bei
          Erfolg fällig; sonst wird sie automatisch erstattet. Durch einen Vertrag gedeckte Wartungen
          kosten nichts zusätzlich.
        </td>
        <td>39,00&nbsp;€ (kleiner Fall) / 78,00&nbsp;€ (größerer Fall)</td>
      </tr>
    </tbody>
  </table>

  <h2>2. Die Safes (Passwort-Safe und Akten-Safe)</h2>
  <p>
    Die Safes sind das Kombiprodukt des Anbieters aus KF Passwort-Safe und durchsuchbarem
    KF Akten-Safe, einschließlich Einrichtung, Einweisung und Produkt-Support. Leistungsumfang
    und Vertragsbedingungen ergeben sich aus den
    <a href="/besondere-bedingungen">Besonderen Bedingungen für die Safes</a>
    (Vertragsergänzung); der Vertragsschluss erfolgt auf Grundlage eines Angebots des Anbieters.
    Bis zum 01.09.2026 wurde dieses Kombiprodukt unter dem Namen „Vertraut" angeboten.
  </p>
  <table>
    <tbody>
      <tr>
        <td>Safes für Vereine</td>
        <td>49,00&nbsp;€ je Monat (Abrechnung als Jahresrechnung, 588,00&nbsp;€/Jahr)</td>
      </tr>
      <tr>
        <td>Safes für Betriebe (bis 10 Nutzer)</td>
        <td>69,00&nbsp;€ je Monat (Abrechnung je Quartal)</td>
      </tr>
      <tr>
        <td>Einmalige Einrichtung (Vereine / Betriebe)</td>
        <td>149,00&nbsp;€ / 199,00&nbsp;€</td>
      </tr>
      <tr>
        <td>Betriebe mit mehr als 10 Nutzern, Privathaushalte</td>
        <td>auf Anfrage</td>
      </tr>
    </tbody>
  </table>
  <p>
    Im Produktpreis enthalten ist der Support für die Bestandteile der Safes (Einrichtung,
    Einweisung, Fragen zum Produkt). Allgemeine IT-Dienstleistungen darüber hinaus werden nach
    Abschnitt&nbsp;1 abgerechnet.
  </p>

  <h2>3. Sonderleistungen zu den Safes</h2>
  <table>
    <tbody>
      <tr>
        <td>
          Wiederherstellung eines gelöschten Safe-Kontos aus der Sicherung — nur solange eine
          Sicherungskopie vorhanden ist (siehe Besondere Bedingungen Nr.&nbsp;6), ausschließlich
          auf schriftlichen Antrag des Kunden
        </td>
        <td>1.000,00&nbsp;€ einmalig</td>
      </tr>
    </tbody>
  </table>

  <h2>4. Allgemeine Hinweise</h2>
  <ul>
    <li>Alle Preise verstehen sich in Euro inklusive der gesetzlichen Umsatzsteuer.</li>
    <li>
      Der Anbieter kann dieses Verzeichnis für künftige Vertragsschlüsse jederzeit anpassen,
      Leistungen hinzufügen oder einstellen. Für bestehende Verträge ist die bei Vertragsschluss
      veröffentlichte Fassung maßgeblich; vereinbarte Konditionen bestehender Verträge bleiben
      unberührt.
    </li>
    <li>
      Früher angebotene Support-Tarife (Basic, Standard, Premium) sowie die Einzelbuchung von
      Passwort-Safe und Dokumentensystem werden nicht mehr für Neuabschlüsse angeboten.
      Bestandsverträge laufen zu den vereinbarten Konditionen fort.
    </li>
  </ul>

  <p class="stand">Stand: 15.10.2026 (zuvor 05.09.2026; neu: Anleitung und Fernwartungspauschale als Einzelleistungen in Abschnitt 1)</p>
</div>

<style>
  table {
    width: 100%;
    border-collapse: collapse;
    margin: 1rem 0 1.5rem;
  }

  td {
    padding: 0.6rem 0.75rem;
    border: 1px solid #e7edf3;
    vertical-align: top;
  }

  td:last-child {
    white-space: nowrap;
    font-weight: 600;
  }

  @media (max-width: 40rem) {
    td:last-child {
      white-space: normal;
    }
  }
</style>
